// Admin dashboards reuse one control contract so filters share spacing and focus behavior without bloating global primitives. (DL-002, DL-003)
export const ADMIN_DASHBOARD_PAGE_SIZE = 10;

const ADMIN_DASHBOARD_CONTROL_BASE_CLASS =
  "rounded-sm border border-stroke bg-white outline-hidden transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary";

// Admin table filters use a local contract to keep admin-specific spacing out of global primitives.
export const ADMIN_DASHBOARD_TEXT_INPUT_CLASS = `${ADMIN_DASHBOARD_CONTROL_BASE_CLASS} py-2 px-3 disabled:cursor-default disabled:bg-whiter`;

export const ADMIN_DASHBOARD_NUMBER_INPUT_CLASS = `${ADMIN_DASHBOARD_CONTROL_BASE_CLASS} w-20 py-2 px-3`;

export const ADMIN_DASHBOARD_SELECT_CLASS = `${ADMIN_DASHBOARD_CONTROL_BASE_CLASS} w-full appearance-none p-2 pl-4 pr-8`;

export const ADMIN_DASHBOARD_PAGE_INPUT_CLASS =
  "w-14 rounded-md border border-stroke bg-transparent px-2 py-1 font-medium text-center outline-hidden ring-0 transition focus:border-primary focus:ring-0 active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary";

export const ADMIN_DASHBOARD_SELECT_CONTAINER_CLASS =
  "grow relative z-20 rounded-sm border border-stroke pr-8 outline-hidden bg-white transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input";
